/* parfium.com etkileşimleri: mobil çekmece, mega menü, canlı arama, AJAX sepet, ürün sayfası paneli */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fmt = function (cents) {
    return (cents / 100).toLocaleString('bg-BG', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  };

  /* ---------- Sepet ---------- */
  function setCartCount(n) {
    document.querySelectorAll('[data-pf-cart-long]').forEach(function (el) {
      el.textContent = n + ' ' + (n === 1 ? 'продукт' : 'продукта');
    });
    document.querySelectorAll('[data-pf-cart-short]').forEach(function (el) { el.textContent = n; });
  }
  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); return c; });
  }
  function addToCart(id, qty) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Грешка');
        return refreshCart();
      });
    });
  }
  function flash(btn, text) {
    var el = btn.querySelector('[data-pf-label]') || btn; // simgeli butonlarda sadece yazı değişir
    var orig = btn.dataset.pfLabel || el.textContent;
    btn.dataset.pfLabel = orig;
    el.textContent = text;
    clearTimeout(btn._pfT);
    btn._pfT = setTimeout(function () { el.textContent = orig; }, 1500);
  }

  // Ürün kartlarındaki "Добави в количката" formları
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-pf-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    var id = form.querySelector('[name=id]').value;
    btn.disabled = true;
    addToCart(id, 1)
      .then(function () { flash(btn, 'Добавено ✓'); })
      .catch(function (err) { flash(btn, err.message); })
      .finally(function () { btn.disabled = false; });
  });

  /* ---------- Mobil çekmece ---------- */
  var drawer = document.querySelector('[data-pf-drawer]');
  if (drawer) {
    document.querySelectorAll('[data-pf-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () { drawer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; });
    });
    drawer.querySelectorAll('[data-pf-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () { drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; });
    });
  }

  /* ---------- Mega menü (tıkla-aç, dışarı tıkla / Esc ile kapat) ---------- */
  var mega = document.querySelector('[data-pf-mega]');
  if (mega) {
    var openKey = null;
    var setOpen = function (key) {
      openKey = key;
      mega.querySelectorAll('[data-pf-mega-btn]').forEach(function (b) {
        var on = b.dataset.pfMegaBtn === key;
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        b.classList.toggle('is-open', on);
      });
      mega.querySelectorAll('[data-pf-mega-panel]').forEach(function (p) { p.hidden = p.dataset.pfMegaPanel !== key; });
    };
    mega.querySelectorAll('[data-pf-mega-btn]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(openKey === b.dataset.pfMegaBtn ? null : b.dataset.pfMegaBtn); });
    });
    document.addEventListener('pointerdown', function (e) { if (openKey && !mega.contains(e.target)) setOpen(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(null); });
  }

  /* ---------- Arama: boşken kategori/nota/popüler paneli, yazarken canlı sonuçlar ---------- */
  document.querySelectorAll('[data-pf-search]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-pf-search-input]');
    var panel = wrap.querySelector('[data-pf-search-panel]');
    var idle = wrap.querySelector('[data-pf-search-idle]');
    var res = wrap.querySelector('[data-pf-search-results]');
    var list = wrap.querySelector('[data-pf-search-list]');
    var empty = wrap.querySelector('[data-pf-search-empty]');
    var loading = wrap.querySelector('[data-pf-search-loading]');
    var all = wrap.querySelector('[data-pf-search-all]');
    var timer = null, seq = 0;

    function open() {
      if (!panel.hidden) return;
      panel.hidden = false;
      document.documentElement.classList.add('pf-search-open');
    }
    function close() {
      panel.hidden = true;
      document.documentElement.classList.remove('pf-search-open');
    }
    function render(term, products) {
      loading.hidden = true;
      all.href = root + 'search?q=' + encodeURIComponent(term) + '&type=product';
      all.hidden = products.length === 0;
      empty.hidden = products.length > 0;
      empty.textContent = 'Няма намерени продукти за «' + term + '».';
      list.innerHTML = products.map(function (p) {
        var name = p.title;
        if (p.vendor && name.toLowerCase().indexOf(p.vendor.toLowerCase() + ' ') === 0) name = name.slice(p.vendor.length + 1);
        var tags = p.tags || [];
        var gender = tags.indexOf('Дамски') > -1 ? 'Дамски' : tags.indexOf('Мъжки') > -1 ? 'Мъжки' : tags.indexOf('Унисекс') > -1 ? 'Унисекс' : '';
        var vols = (p.variants || []).map(function (v) { return (v.title || '').replace(/\s*ml$/i, ''); })
          .filter(function (t) { return /^\d+$/.test(t); });
        var meta = [gender, vols.length ? vols.join(' / ') + ' мл' : '', tags.indexOf('Без опаковка') > -1 ? 'без опаковка' : ''].filter(Boolean).join(' · ');
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        return '<li><a href="' + esc(p.url) + '" class="pf-sp__hit">' +
          '<span class="pf-sp__himg">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(name) + '">' : esc((p.vendor || name).slice(0, 2).toUpperCase())) + '</span>' +
          '<span class="pf-sp__htext">' + (p.vendor ? '<span class="pf-sp__hbrand">' + esc(p.vendor) + '</span>' : '') +
          '<span class="pf-sp__hname">' + esc(name) + '</span>' +
          (meta ? '<span class="pf-sp__hmeta">' + esc(meta) + '</span>' : '') + '</span>' +
          '<span class="pf-sp__hprice">' + fmt(Math.round(parseFloat(p.price_min || p.price) * 100)) + '</span></a></li>';
      }).join('');
    }
    function search(term) {
      var my = ++seq;
      loading.hidden = false;
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag,variants.sku')
        .then(function (r) { return r.json(); })
        .then(function (d) { if (my === seq) render(term, (d.resources && d.resources.results && d.resources.results.products) || []); })
        .catch(function () { if (my === seq) render(term, []); });
    }

    input.addEventListener('focus', open);
    input.addEventListener('input', function () {
      var term = input.value.trim();
      open();
      clearTimeout(timer);
      var searching = term.length >= 2;
      idle.hidden = searching;
      res.hidden = !searching;
      if (!searching) { list.innerHTML = ''; return; }
      list.innerHTML = '';
      empty.hidden = false;
      empty.textContent = 'Търсене…';
      all.hidden = true;
      timer = setTimeout(function () { search(term); }, 200);
    });
    wrap.querySelector('[data-pf-search-close]').addEventListener('click', function () { close(); input.blur(); });
    document.addEventListener('mousedown', function (e) { if (!panel.hidden && !wrap.contains(e.target)) close(); });
    document.addEventListener('touchstart', function (e) { if (!panel.hidden && !wrap.contains(e.target)) close(); }, { passive: true });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });

  /* ---------- Katalog: mobil filtre aç/kapa, fiyat aralığı, sıralama ---------- */
  document.querySelectorAll('[data-pf-filters]').forEach(function (box) {
    var t = box.querySelector('[data-pf-filters-toggle]');
    t.addEventListener('click', function () {
      var open = box.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open);
    });
  });

  function goWith(mutate) {
    var url = new URL(location.href);
    mutate(url.searchParams);
    url.searchParams.delete('page');
    location.href = url.toString();
  }

  // Shopify'ın 100 değer sınırı dışında kalan markalar: filtreyi URL'e ekle
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pf-add-filter]');
    if (!a) return;
    e.preventDefault();
    var key = a.dataset.pfAddFilter, val = a.dataset.value;
    goWith(function (p) {
      var cur = p.getAll(key);
      p.delete(key);
      if (cur.indexOf(val) > -1) cur.splice(cur.indexOf(val), 1); else cur.push(val);
      cur.forEach(function (v) { p.append(key, v); });
    });
  });
  // Seçili (listede olmayan) markaları vurgula + "Избрани филтри" kutusuna ekle
  (function () {
    var items = document.querySelectorAll('[data-pf-add-filter]');
    if (!items.length) return;
    var params = new URL(location.href).searchParams;
    var marked = [];
    items.forEach(function (a) {
      if (params.getAll(a.dataset.pfAddFilter).indexOf(a.dataset.value) > -1) { a.classList.add('is-active'); marked.push(a); }
    });
    if (!marked.length) return;
    var list = marked[0].closest('.pf-flist');
    var all = list && list.querySelector('.pf-fitem:not([data-pf-add-filter])');
    if (all && !all.querySelector('.pf-fitem__n')) all.classList.remove('is-active');
    var body = document.querySelector('.pf-filters__body');
    var box = body && body.querySelector('.pf-fbox--active .pf-fchips');
    if (body && !box) {
      var wrap = document.createElement('div');
      wrap.className = 'pf-fbox pf-fbox--active';
      var clear = location.pathname + (params.get('q') ? '?q=' + encodeURIComponent(params.get('q')) + '&type=product' : '');
      wrap.innerHTML = '<div class="pf-fbox__head"><h3>Избрани филтри</h3><a href="' + clear + '" class="pf-fclear">Изчисти всички</a></div><div class="pf-fchips"></div>';
      body.insertBefore(wrap, body.firstChild);
      box = wrap.querySelector('.pf-fchips');
    }
    marked.forEach(function (a) {
      var chip = document.createElement('a');
      chip.href = '#'; chip.className = 'pf-fchip is-active';
      chip.dataset.pfAddFilter = a.dataset.pfAddFilter; chip.dataset.value = a.dataset.value;
      chip.textContent = a.dataset.value + ' ✕';
      box && box.appendChild(chip);
    });
  })();

  document.querySelectorAll('[data-pf-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      goWith(function (p) { p.set('sort_by', sel.value); });
    });
  });

  document.querySelectorAll('[data-pf-price]').forEach(function (box) {
    var min = +box.dataset.min, max = +box.dataset.max, span = Math.max(1, max - min);
    var loIn = box.querySelector('[data-pf-price-lo]'), hiIn = box.querySelector('[data-pf-price-hi]');
    var track = box.querySelector('[data-pf-price-track]'), fill = box.querySelector('[data-pf-price-fill]');
    var kLo = box.querySelector('[data-pf-price-knob=lo]'), kHi = box.querySelector('[data-pf-price-knob=hi]');
    var lo = +loIn.value, hi = +hiIn.value, active = null;
    var clamp = function (v) { return Math.min(Math.max(v, min), max); };
    var pct = function (v) { return ((v - min) / span) * 100; };
    function draw() {
      var a = Math.min(lo, hi), b = Math.max(lo, hi);
      fill.style.left = pct(a) + '%'; fill.style.right = (100 - pct(b)) + '%';
      kLo.style.left = pct(a) + '%'; kHi.style.left = pct(b) + '%';
      loIn.value = a; hiIn.value = b;
    }
    function commit() {
      var a = clamp(Math.min(lo, hi)), b = clamp(Math.max(lo, hi));
      goWith(function (p) {
        if (a > min) p.set(box.dataset.gte, a); else p.delete(box.dataset.gte);
        if (b < max) p.set(box.dataset.lte, b); else p.delete(box.dataset.lte);
      });
    }
    function valueAt(x) {
      var r = track.getBoundingClientRect();
      return Math.round(min + Math.min(1, Math.max(0, (x - r.left) / r.width)) * span);
    }
    track.addEventListener('pointerdown', function (e) {
      var v = valueAt(e.clientX);
      active = Math.abs(v - lo) <= Math.abs(v - hi) ? 'lo' : 'hi';
      if (active === 'lo') lo = Math.min(v, hi); else hi = Math.max(v, lo);
      draw();
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function (e) {
      if (!active) return;
      var v = valueAt(e.clientX);
      if (active === 'lo') lo = Math.min(v, hi); else hi = Math.max(v, lo);
      draw();
    });
    track.addEventListener('pointerup', function (e) {
      if (!active) return;
      active = null;
      track.releasePointerCapture(e.pointerId);
      commit();
    });
    [loIn, hiIn].forEach(function (inp) {
      inp.addEventListener('change', function () {
        lo = clamp(+loIn.value || min); hi = clamp(+hiIn.value || max);
        draw(); commit();
      });
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') inp.blur(); });
    });
    draw();
  });

  /* ---------- Teslimat tarihi sayacı: Sofya saatiyle 15:00'e kadar +2 gün, sonrası +3 gün ---------- */
  document.querySelectorAll('[data-pf-eta]').forEach(function (box) {
    var cutoff = +box.dataset.cutoff || 15, days = +box.dataset.days || 2;
    var dateEl = box.querySelector('[data-pf-eta-date]'), countEl = box.querySelector('[data-pf-eta-count]'), leftEl = box.querySelector('[data-pf-eta-left]');
    var fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Sofia', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var p = {};
      fmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = +x.value; });
      var secNow = p.hour * 3600 + p.minute * 60 + p.second, secCut = cutoff * 3600;
      var before = secNow < secCut;
      var d = new Date(Date.UTC(p.year, p.month - 1, p.day + days + (before ? 0 : 1)));
      if (d.getUTCDay() === 0) d.setUTCDate(d.getUTCDate() + 1); // pazar teslimat yok → pazartesi
      dateEl.textContent = pad(d.getUTCDate()) + '.' + pad(d.getUTCMonth() + 1) + '.' + d.getUTCFullYear();
      var left = before ? secCut - secNow : 86400 - secNow + secCut;
      var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
      leftEl.textContent = (h ? h + ' ч ' : '') + pad(m) + ' мин ' + pad(s) + ' сек';
      countEl.hidden = false;
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Ürün sayfası: galeri + boyut seçimi + adet + sepete ekle / hemen al ---------- */
  document.querySelectorAll('[data-pf-product]').forEach(function (pg) {
    var main = pg.querySelector('[data-pf-gallery-main]');
    pg.querySelectorAll('[data-pf-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.pfThumb;
        var ti = t.querySelector('img'); if (ti && ti.alt) main.alt = ti.alt;
        pg.querySelectorAll('[data-pf-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-current', x === t); });
      });
    });

    var variants = pg.querySelectorAll('[data-pf-variant]');
    var qtyEl = pg.querySelector('[data-pf-qty]');
    var addBtn = pg.querySelector('[data-pf-add-btn]');
    var buyBtn = pg.querySelector('[data-pf-buy-btn]');
    var skuEl = pg.querySelector('[data-pf-sku]');
    var qty = 1;
    var current = pg.querySelector('[data-pf-variant].is-selected') || variants[variants.length - 1];

    function select(v) {
      current = v;
      variants.forEach(function (x) { x.classList.toggle('is-selected', x === v); x.setAttribute('aria-pressed', x === v); });
      qty = 1; qtyEl.textContent = qty;
      var avail = v.dataset.available === 'true';
      addBtn.disabled = buyBtn.disabled = !avail;
      addBtn.textContent = avail ? 'Добави в количката' : 'Изчерпан';
      addBtn.dataset.pfLabel = addBtn.textContent;
      if (skuEl) skuEl.textContent = v.dataset.sku || '—';
      if (v.dataset.image && main) {
        main.src = v.dataset.image;
      }
      var url = new URL(location.href);
      url.searchParams.set('variant', v.dataset.pfVariant);
      history.replaceState(null, '', url);
    }
    variants.forEach(function (v) { v.addEventListener('click', function () { select(v); }); });
    if (current) select(current);

    pg.querySelector('[data-pf-qty-minus]').addEventListener('click', function () { qty = Math.max(1, qty - 1); qtyEl.textContent = qty; });
    pg.querySelector('[data-pf-qty-plus]').addEventListener('click', function () { qty = Math.min(99, qty + 1); qtyEl.textContent = qty; });

    addBtn.addEventListener('click', function () {
      if (!current) return;
      addBtn.disabled = true;
      addToCart(current.dataset.pfVariant, qty)
        .then(function () { flash(addBtn, 'Добавено ✓'); })
        .catch(function (err) { flash(addBtn, err.message); })
        .finally(function () { addBtn.disabled = false; });
    });
    buyBtn.addEventListener('click', function () {
      if (!current) return;
      buyBtn.disabled = true;
      addToCart(current.dataset.pfVariant, qty)
        .then(function () { location.href = root + 'checkout'; })
        .catch(function (err) { buyBtn.disabled = false; flash(buyBtn, err.message); });
    });

    // "Може да харесате" — Shopify öneri motoru (section rendering)
    var rel = pg.querySelector('[data-pf-related]');
    if (rel) {
      fetch(rel.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-pf-related-inner]');
        if (inner && inner.querySelector('.pf-card')) rel.replaceWith(inner);
        else rel.remove();
      }).catch(function () { rel.remove(); });
    }
  });
})();

/* ---------- Mega menü / arama paneli kartlarını ilk açılışta yükle ---------- */
(function () {
  var loaded = false, loading = null;
  function load() {
    if (loaded || loading) return loading;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    loading = fetch(root + '?section_id=pf-lazy').then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      document.querySelectorAll('[data-pf-lazy]').forEach(function (slot) {
        var t = tmp.querySelector('[data-pf-lazy-src="' + slot.dataset.pfLazy + '"]');
        if (t) slot.outerHTML = t.innerHTML;
      });
      loaded = true;
    }).catch(function () { loading = null; });
    return loading;
  }
  ['mouseover', 'focusin', 'touchstart', 'click'].forEach(function (ev) {
    document.querySelectorAll('[data-pf-mega], [data-pf-search], [data-pf-drawer-open]').forEach(function (el) { el.addEventListener(ev, load, { once: true, passive: true }); });
  });
  var later = function () { setTimeout(load, 3500); };
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
})();
